var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"essential",style:({width: _vm.size || '40px', height: _vm.size || '40px'})},[_c('svg',{class:'icon ' + _vm.getIconClass(_vm.appName),style:(_vm.getDimensions()),attrs:{"id":'svg-' + _vm.svgId,"viewBox":"0 0 58 58"}},[_c('use',{attrs:{"xlink:href":'#' + _vm.appName}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }